import * as React from 'react';
export function ParallaxMedia(_a) {
    var urls = _a.urls;
    var _b = React.useState(0), scrollPos = _b[0], setScrollPos = _b[1];
    var _c = React.useState(0), containerYPos = _c[0], setContainerYPos = _c[1];
    var ref = React.useRef(null);
    React.useEffect(function () {
        var handleScroll = function () {
            var scrollY = window.scrollY;
            setScrollPos(scrollY);
        };
        document.addEventListener('scroll', handleScroll);
        return function () {
            document.removeEventListener('scroll', handleScroll);
        };
    }, []);
    React.useEffect(function () {
        var container = ref.current;
        if (container) {
            var rect = container.getBoundingClientRect();
            setContainerYPos(rect.top + window.scrollY);
        }
    }, [ref]);
    var setClassName = function (index) {
        if (!containerYPos) {
            return;
        }
        var startPx = containerYPos - (window.innerHeight / 1.5);
        if (scrollPos > startPx) {
            return 'netset-animate-in';
        }
        return '';
    };
    var setCss = function (index) {
        return {
            transitionDelay: "".concat(25 + (index * 250), "ms"),
            animationDelay: "".concat(25 + (index * 175), "ms")
        };
    };
    return (React.createElement("div", { ref: ref, className: 'netset-parallax-media-container' },
        React.createElement("div", { className: 'netset-parallax-media-positioning' }, urls.map(function (url, i) {
            return React.createElement("img", { className: setClassName(i), key: i, src: url, style: setCss(i), alt: 'Decorative image.', loading: 'lazy' });
        }))));
}
